import Tesseract from 'tesseract.js'
import axios from 'axios'

//var fs = require('fs');

export default {
  methods: {
    convertBlobToImage(blob) {
      return new Promise((resolve,reject) => {
        let pdffile = new File([blob], 'file.pdf');
        let fd = new FormData();
        fd.append('image',pdffile, 'file.pdf');


        axios.post(process.env.VUE_APP_PDF2PNG_SERVER, fd, {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        }).then(resp => {
          // response must be base64 encoded png
          resolve(resp)
        }).catch(err => {
          reject(err)
        })
      })
    },
    recognizeDocument(img) {
      return new Promise((resolve,reject) => {
        Tesseract.recognize(img, 'deu', {
          workerPath: 'https://cdn.t.socialguard.app/files/tesseract/worker.min.js',
          langPath: 'https://cdn.t.socialguard.app/files/tesseract/lang-data/',
          corePath: 'https://cdn.t.socialguard.app/files/tesseract/tesseract-core.wasm.js'
           }
      ).then(({ data: { text } }) => {
        resolve(this.recognizeDocumentText(text))
      }).catch(err => {
          reject(err)
        })
      })
    },
    recognizeDocumentText:function (text) {
      // eslint-disable-next-line no-console
      console.log(text)
      var dates = text.match(/\d{2}([/.-])\d{2}\1\d{4}/g);
      var newDates = [];
      var expires = null;
      var issued = null;

      //convert to date
      if (dates !== null) {
        dates.forEach(date => {
          newDates.push(new Date(date.split('.').reverse().join('/')))

          //sort desc
          newDates.sort(function (a, b) {
            // Turn your strings into dates, and then subtract them
            // to get a value that is either negative, positive, or zero.
            return b - a;
          });

          //guess issued and expiresAt
          if (newDates[0] > new Date()) {
            expires = newDates[0]
            issued = newDates[1]
          } else {
            issued = newDates[0]
          }
        })
      }

      let output = {
        issuedAt: issued,
        expiresAt: (expires !== null) ? expires : null,
        name: null,
        type: null,
        description: null};


      if (text.toLowerCase().includes('modul a')) {
        output.name = 'Modul A';
        output.type = 'Schulung';
        output.description = 'Präventionsschulung ServicemitarbeiterIn';
      }
      if (text.toLowerCase().includes('modul b')) {
        output.name = 'Modul B';
        output.type = 'Schulung';
        output.description = 'Präventionsschulung leitende MitarbeiterIn';
      }
      if (text.toLowerCase().includes('8 abs. 2')) {
        output.name = 'Bescheinigung §8 Abs. 2 NSpielhG';
        output.type = 'Schulung';
        output.description = 'Bescheinigung §8 Abs. 2 NSpielhG';
      }
      if (text.toLowerCase().includes('sächsglüstvag')) {
        output.name = 'Spielsucht Präventionsschulung';
        output.type = 'Schulung';
        output.description = 'Spielsucht Präventionsschulung';
      }

      return output;
    }

  }
}